import { Component, OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef} from '@angular/core';
import { ReactiveFormsModule, FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import {DemoService} from '../../../../demo.service';
import {Routes, RouterModule, Router} from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
// Notifications
import { HotToastService } from '@ngneat/hot-toast';
import { JobTypeDocument } from '../../../../shared/models/jobTypeDocument.model';

import { CreateJobTypeComponent} from './../create-job-type.component';

import { BsModalService } from 'ngx-bootstrap/modal';
import { GlobalFunctionsService } from 'src/app/services/global-functions.service';


@Component({
  selector: 'app-create-document',
  templateUrl: './create-document.component.html',
  styleUrls: ['./create-document.component.css']
})
export class CreateDocumentComponent implements OnInit {


   // setup as observable?
   @Input() item_id?; // impliments on changes.
   @Input() item_data?; // if data.model is sent : Observable<any[]>;
   @Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
   @Input() item_user_level_id? = '5'; // default to agent just in case
   @Input() item_brand_type_id? = '';
   @Input() show_buttons? = 'no'; // yes | no
   @Input() widget_title? = '';
   @Input() widget_size? = 'side'; // side | abstract | full


  model: JobTypeDocument;
  job_types: any;
  job_type_locations: any;
  count2: any;
  get_latest_court_id: any;
  job_type_courts: any;
  sent_job_type_location_id: any;
  get_latest_document_id: any;
  job_type_affidavit_types: any;
  sent_job_type_document_type_id: any;
  @Output('closeParentModel') closeParentModel: EventEmitter<any> = new EventEmitter();

// for report tools
@Input() job_type_name?;
@Input() job_type_id?;
@Input() job_type_location_name?;
@Input() job_type_location_id?;
@Input() job_type_court_name?;
@Input() job_type_court_id?;
@Input() job_type_document_type_name?;
@Input() job_type_document_type_id?;

  constructor(
    private http: HttpClient,
    private _demoService: DemoService,
    private route: ActivatedRoute,
    private router: Router,
    public toastr: HotToastService,
    vcr: ViewContainerRef,
    private modalService: BsModalService, viewRef: ViewContainerRef,
    public gfunc: GlobalFunctionsService
  ) { }

  // check for changes. to load data.
  ngOnChanges(changes) {
    if (changes.item_id) {
      // deal with asynchronous Observable result
      this.job_type_id = changes.item_id.currentValue;
     // test to see if loads undefined better.
     // this.job_id = this.item_id;

      // this.getJob(this.job_id);
      this.toastr.success('Presets loaded' , this.job_type_id);
  


     // stops error on subjects page not having a job id initally
     if(this.job_type_id >= 1){

      this.model = new JobTypeDocument();

      this.model.job_type_id = this.job_type_id;
      this.model.job_type_location_id = this.job_type_location_id;
      this.model.job_type_court_id = this.job_type_court_id;
      // this.model.job_type_document_type_id = this.job_type_document_type_id as number; // for some reason no double quotes in json as it was converted to string somewhere olong the line

 

      setTimeout(() => {  
        console.log("A Simple Pause!"); 
        this.getJobTypes();
        this.getJobTypeLocations(this.job_type_id);
        this.getJobTypeCourts(this.job_type_location_id);
        console.log("Now Ready to load...");
      }, 900);

     }

      // :: Not needed to load for side 
      if (this.widget_size != 'side'){
      // this.getJobPlaintiffs(this.job_id); 
      // this.getJobReportSubjects(this.job_id);
      // this.getJobSubjectDocumentsByJobID(this.job_id);
      }

    }
  }


  ngOnInit() {
    this.model = new JobTypeDocument();
    this.getJobTypes();
  }


  getJobTypes() {
    this._demoService.getJobTypes().subscribe(
       data => { this.job_types = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  
  
   getJobTypeLocations(job_type_id) {
    this._demoService.getJobTypeLocations(job_type_id).subscribe(
       data => { this.job_type_locations = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  

   sendJobTypeLocationsID(job_type_id) {
    // this.initialCount = this.trace_candidates.trace_candidate_id;
    this.count2 = job_type_id;
    this.getJobTypeLocations(this.count2); // updates the selected job ID....
    this.model.job_type_location_id = 1;
    this.model.job_type_court_id = 0;
    // this.model.job_type_document_type_id = 0;
    // this.model.job_type_affidavit_type_id = 0;

  }



  createJobTypeDocument(model) {
    // console.log(model);
        this._demoService.createJobTypeDocuemnt(model).subscribe(
             data => {  this.get_latest_document_id = data; // this is the retuned json upon creation.
     
               this.traceAddNotice ();
     /*
             // tslint:disable-next-line:max-line-length
             this.router.navigateByUrl('/manager/brand-client-manager/' + this.model.client_brand_id, {skipLocationChange: true}).then(() =>
             this.router.navigate(['/manager/brand-client-contact-manager/' + this.model.brand_id + '/' + this.model.client_brand_id]));
     */
             this.closeParentModel.emit();
   // CreateJobTypeComponent.returned.next(false);
               //  return true;
             },
             error => {
               this.toastr.error('Adding Court Failed :: Please try again!');
               // console.log(Observable.throw(error));
               // return Observable.throw(error);
             }
        );
        }
 
 
        traceAddNotice () {
         this.toastr.info('Document Added');
       };
 



       getJobTypeCourts(job_type_location_id) {
        this._demoService.getJobTypeCourts(job_type_location_id).subscribe(
           data => { this.job_type_courts = data; },
           err => console.error(err),
           // () => console.log('done loading Trace Types')
         );
       }
      
      
       sendJobTypeCourtsID(job_type_location_id) {
        // this.initialCount = this.trace_candidates.trace_candidate_id;
        this.sent_job_type_location_id = job_type_location_id;
        this.getJobTypeCourts(this.sent_job_type_location_id); // updates the selected job ID....
      
      }



      getJobTypeAffidavitTypes(job_type_document_type_id) {
        this._demoService.getJobTypeAffidavitTypes(job_type_document_type_id).subscribe(
           data => { this.job_type_affidavit_types = data; },
           err => console.error(err),
           // () => console.log('done loading Trace Types')
         );
       }
      
      
       sendJobTypeAffidavitTypesID(job_type_document_type_id) {
        // this.initialCount = this.trace_candidates.trace_candidate_id;
        this.sent_job_type_document_type_id = job_type_document_type_id;
        this.getJobTypeAffidavitTypes(this.sent_job_type_document_type_id); // updates the selected job ID....
      
       console.log('sending Doc Type:' + this.sent_job_type_document_type_id);
      }



}
